import { Building2, User } from "lucide-react";
import type { UseFormRegister } from "react-hook-form";
import type { TFunction } from "i18next";
import { AccountType, RegistrationValues } from "../types/registration";
import { accentBorder, accentText } from "../styles";

export function AccountTypeSelector({
  t,
  accountType,
  register,
}: {
  t: TFunction;
  accountType: AccountType;
  register: UseFormRegister<RegistrationValues>;
}) {
  return (
    <div>
      <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-[var(--color-charcoalGray)] dark:text-[var(--color-muted)]">
        {t("accountType")}
      </p>
      <div className="grid grid-cols-2 gap-3">
        <label
          className={`group relative flex cursor-pointer items-center justify-center gap-2.5 rounded-xl border px-4 py-3.5 text-sm font-semibold transition-all duration-200 ${
            accountType === "individual"
              ? `${accentBorder} bg-[var(--color-tealGreen)]/8 shadow-md shadow-[var(--color-tealGreen)]/10 dark:bg-[var(--color-primary)]/10 dark:shadow-[var(--color-primary)]/10`
              : "border-[var(--color-border)] hover:border-[var(--color-tealGreen)]/40 hover:shadow-sm dark:border-[var(--color-dark_border)] dark:hover:border-[var(--color-primary)]/40"
          }`}
        >
          <input type="radio" value="individual" className="sr-only" {...register("accountType")} />
          <div
            className={`flex h-8 w-8 items-center justify-center rounded-lg transition-all duration-200 ${
              accountType === "individual"
                ? "bg-[var(--color-tealGreen)]/15 dark:bg-[var(--color-primary)]/20"
                : "bg-[var(--color-grey)] dark:bg-[var(--color-slateGray)]"
            }`}
          >
            <User size={18} className={accountType === "individual" ? accentText : "text-[var(--color-charcoalGray)]"} strokeWidth={accountType === "individual" ? 2.5 : 2} />
          </div>
          <span className={accountType === "individual" ? accentText : "text-[var(--color-midnight_text)] dark:text-[var(--color-white)]"}>
            {t("individual")}
          </span>
        </label>
        <label
          className={`group relative flex cursor-pointer items-center justify-center gap-2.5 rounded-xl border px-4 py-3.5 text-sm font-semibold transition-all duration-200 ${
            accountType === "company"
              ? `${accentBorder} bg-[var(--color-tealGreen)]/8 shadow-md shadow-[var(--color-tealGreen)]/10 dark:bg-[var(--color-primary)]/10 dark:shadow-[var(--color-primary)]/10`
              : "border-[var(--color-border)] hover:border-[var(--color-tealGreen)]/40 hover:shadow-sm dark:border-[var(--color-dark_border)] dark:hover:border-[var(--color-primary)]/40"
          }`}
        >
          <input type="radio" value="company" className="sr-only" {...register("accountType")} />
          <div
            className={`flex h-8 w-8 items-center justify-center rounded-lg transition-all duration-200 ${
              accountType === "company"
                ? "bg-[var(--color-tealGreen)]/15 dark:bg-[var(--color-primary)]/20"
                : "bg-[var(--color-grey)] dark:bg-[var(--color-slateGray)]"
            }`}
          >
            <Building2 size={18} className={accountType === "company" ? accentText : "text-[var(--color-charcoalGray)]"} strokeWidth={accountType === "company" ? 2.5 : 2} />
          </div>
          <span className={accountType === "company" ? accentText : "text-[var(--color-midnight_text)] dark:text-[var(--color-white)]"}>
            {t("company")}
          </span>
        </label>
      </div>
    </div>
  );
}
